import { useMutation } from 'react-query';
import type { AxiosError } from 'axios';
import { client } from '../util/client';

export interface RequestDemoParams {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  referrer?: string;
  speciality?: string;
  variant?: string;
}

export interface DemoRequestResponse {
  id: string;
}

export const useRequestDemo = () =>
  useMutation(
    async (params: RequestDemoParams): Promise<DemoRequestResponse> => {
      const response = await client.post('/demoRequest', params);
      return response.data;
    },
    {
      mutationKey: 'requestDemo',
      // The POST is not idempotent: Accepted trade-off — better a rare
      // duplicate lead than losing one to a flaky mobile connection. Only a
      // request that never got an answer qualifies: any response we did get
      // (a validation 400, a WAF 403/429) would fail identically on the retry.
      retry: (failureCount, error) =>
        failureCount < 1 && !(error as AxiosError)?.response,
    },
  );
